/*esto fue agregado 16hs 4-12-25 la ultima actualizacion*/
import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { TiArrowBack } from "react-icons/ti";
import './StoreSelectionPage.css';

const StoreSelectionPage = ({ onStoreSelected, onBack }) => {
  const { updateSelectedStore, getStores } = useCart();
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedStoreId, setSelectedStoreId] = useState(null);

  const stores = getStores(); // Usar stores del contexto

  const handleStoreSelect = (store) => {
    setSelectedStore(store);
    setSelectedStoreId(store.id);
  };

  const handleConfirmStore = () => {
    if (selectedStore) {
      // Actualizar tienda seleccionada en el contexto
      updateSelectedStore(selectedStore);

      // Navegar de regreso
      onStoreSelected(selectedStore);
    }
  };

  const handleLikeStore = (storeId, e) => {
    e.stopPropagation(); // Evitar que se seleccione la tienda al hacer like
    // En una app real, aquí se enviaría un like a la API
    console.log(`Liked store ${storeId}`);
    alert(`You liked store ${storeId}!`);
  };

  return (
    <div className="store-selection-page">
      <div className="store-selection-container">
        {/* Header */}
        <div className="selection-header">
          <button className="back-button" onClick={onBack}>
            <TiArrowBack />
          </button>
          <h1>Seleccionar tienda Pickup </h1>
          <p className="subtitle">Elige dónde recogerás tu pedido</p>
        </div>

        {/* Lista de tiendas */}
        <div className="stores-list">
          <h2>Tiendas disponibles</h2>
          <p className="instruction">Toque una tienda para seleccionarla y pickup</p>

          {stores.map(store => (
            <div
              key={store.id}
              className={`store-card ${selectedStoreId === store.id ? 'selected' : ''}`}
              onClick={() => handleStoreSelect(store)}
            >
              <div className="store-info">
                <div className="store-header">
                  <h3 className="store-name">{store.name}</h3>
                  <button
                    className="like-btn"
                    onClick={(e) => handleLikeStore(store.id, e)}
                    aria-label={`Like ${store.name}`}
                  >
                    <span className="like-icon">👍</span>
                    <span className="like-count">{store.likes}</span>
                  </button>
                </div>

                <p className="store-address">{store.address}</p>

                <div className="store-hours">
                  {store.hours.split('\n').map((line, index) => (
                    <p key={index} className="hour-line">{line}</p>
                  ))}
                </div>

                <div className="store-distance">
                  <span className="distance-icon">📍</span>
                  <span className="distance-text">{store.distance}</span>
                </div>
              </div>

              <div className="store-selector">
                {selectedStoreId === store.id ? (
                  <div className="selected-indicator">
                    <span className="checkmark">✓</span>
                    <span className="selected-text">Seleccionada</span>
                  </div>
                ) : (
                  <div className="select-indicator">
                    Seleccionar
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Información de la tienda seleccionada */}
        {selectedStore && (
          <div className="selected-store-info">
            <h3>Tienda seleccionada</h3>
            <div className="selected-store-card">
              <h4>{selectedStore.name}</h4>
              <p>{selectedStore.address}</p>
              <p className="pickup-time">Estimado pickup: 10-15 minutos</p>
            </div>
          </div>
        )}

        {/* Botones de acción */}
        <div className="store-selection-actions">
          <button
            className="action-btn secondary"
            onClick={onBack}
          >
            Cancelar
          </button>

          <button
            className="action-btn primary"
            onClick={handleConfirmStore}
            disabled={!selectedStore}
          >
            Confirme la tienda y continue
          </button>
        </div>

        {/* Nota informativa */}
        <div className="store-selection-note">
          <p>💡 <strong>Tip:</strong> Puedes cambiar de tienda para pickup antes de pagar.</p>
          <p>🕒 Los pedidos suelen estar listos entre 10 y 15 minutos después de la compra.</p>
        </div>
      </div>
    </div>
  );
};

export default StoreSelectionPage;